import { PropsWithChildren, memo, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SetReturnStateLink {
    to: string
    className?: string
    title?: string
    children: ReactNode
    testid?: string
}

export default memo(function SetReturnStateLink(props: PropsWithChildren<SetReturnStateLink>) {
    return (<Link
        data-testid={props.testid}
        className={props.className || 'link-offset-2 link-underline-opacity-25'}
        to={props.to}
        state={{ from: window.location.href }}
        preventScrollReset={false}
        title={props.title}
        aria-label={props.title}
    >{props.children}</Link>);
});
